var _g, _g2, _g3, _rect, _path, _rect2, _path2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 137,
    viewBox: "0 0 270 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 98C49.6731 98 64 83.6731 64 66C64 48.3269 49.6731 34 32 34C14.3269 34 0 48.3269 0 66C0 83.6731 14.3269 98 32 98Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1232 71.3995L35.8287 70.7124C34.6508 68.8473 34.0619 66.197 33.8656 63.4486C33.5711 57.0682 35.8287 52.0621 39.4607 51.7676H39.657C42.8962 51.7676 45.841 56.2829 46.3318 62.467C46.5281 65.2154 46.1355 67.7676 45.3502 69.8289L45.1539 70.516H44.4668C43.2889 70.3197 41.8165 70.3197 40.7367 70.516C39.4607 70.516 38.0864 70.9087 37.0067 71.2032L36.1232 71.3995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9759 69.6319L28.2704 68.9448C29.4483 67.0798 30.0372 64.4295 30.2336 61.681C30.528 55.3006 28.2704 50.2945 24.6385 50H24.5403C21.301 50 18.3563 54.5153 17.8655 60.6994C17.6691 63.4479 18.0618 66 18.8471 68.0614L19.0434 68.7485H19.6323C20.8102 68.5522 22.2826 68.5522 23.3624 68.7485C24.6385 68.7485 26.0127 69.1411 27.0925 69.4356L27.9759 69.6319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0495 82.099C37.301 82.099 35.436 78.8598 35.6323 74.9334C35.6323 74.6389 35.6323 74.1481 35.6323 73.8536L35.8286 73.0684L44.5648 73.3628V74.2463C44.5648 74.5408 44.5648 75.0315 44.5648 75.326C44.663 79.1542 42.6016 82.099 40.0495 82.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9522 80.3334C26.7006 80.3334 28.5657 77.0941 28.3693 73.1678C28.3693 72.8733 28.3693 72.3825 28.3693 72.088L28.173 71.3027L19.4368 71.5972V72.3825C19.4368 72.677 19.4368 73.1678 19.4368 73.4622C19.3387 77.2905 21.4982 80.3334 23.9522 80.3334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 98C145.673 98 160 83.6731 160 66C160 48.3269 145.673 34 128 34C110.327 34 96 48.3269 96 66C96 83.6731 110.327 98 128 98Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.123 71.3995L131.829 70.7124C130.651 68.8473 130.062 66.197 129.866 63.4486C129.571 57.0682 131.829 52.0621 135.461 51.7676H135.657C138.896 51.7676 141.841 56.2829 142.332 62.467C142.528 65.2154 142.135 67.7676 141.35 69.8289L141.154 70.516H140.467C139.289 70.3197 137.816 70.3197 136.737 70.516C135.461 70.516 134.086 70.9087 133.007 71.2032L132.123 71.3995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.976 69.6319L124.27 68.9448C125.448 67.0798 126.037 64.4295 126.234 61.681C126.528 55.3006 124.27 50.2945 120.638 50H120.54C117.301 50 114.356 54.5153 113.865 60.6994C113.669 63.4479 114.062 66 114.847 68.0614L115.043 68.7485H115.632C116.81 68.5522 118.283 68.5522 119.362 68.7485C120.638 68.7485 122.013 69.1411 123.092 69.4356L123.976 69.6319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.049 82.099C133.301 82.099 131.436 78.8598 131.632 74.9334C131.632 74.6389 131.632 74.1481 131.632 73.8536L131.829 73.0684L140.565 73.3628V74.2463C140.565 74.5408 140.565 75.0315 140.565 75.326C140.663 79.1542 138.602 82.099 136.049 82.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.952 80.3334C122.701 80.3334 124.566 77.0941 124.369 73.1678C124.369 72.8733 124.369 72.3825 124.369 72.088L124.173 71.3027L115.437 71.5972V72.3825C115.437 72.677 115.437 73.1678 115.437 73.4622C115.339 77.2905 117.498 80.3334 119.952 80.3334Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 106C246.091 106 264 88.0914 264 66C264 43.9086 246.091 26 224 26C201.909 26 184 43.9086 184 66C184 88.0914 201.909 106 224 106Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.153 72.7508L228.785 71.8919C227.313 69.5606 226.576 66.2477 226.331 62.8122C225.963 54.8367 228.785 48.579 233.325 48.2109H233.57C237.619 48.2109 241.3 53.8551 241.914 61.5852C242.159 65.0208 241.668 68.2109 240.687 70.7876L240.441 71.6465H239.583C238.11 71.4011 236.27 71.4011 234.92 71.6465C233.325 71.6465 231.607 72.1373 230.257 72.5054L229.153 72.7508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.969 70.5399L219.337 69.681C220.81 67.3497 221.546 64.0368 221.791 60.6012C222.159 52.6258 219.337 46.3681 214.797 46H214.675C210.626 46 206.945 51.6442 206.331 59.3742C206.086 62.8098 206.576 66 207.558 68.5767L207.803 69.4356H208.54C210.012 69.1902 211.853 69.1902 213.202 69.4356C214.797 69.4356 216.515 69.9264 217.865 70.2945L218.969 70.5399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.062 86.1243C230.626 86.1243 228.295 82.0752 228.54 77.1672C228.54 76.7991 228.54 76.1856 228.54 75.8175L228.786 74.8359L239.706 75.204V76.3083C239.706 76.6764 239.706 77.2899 239.706 77.658C239.828 82.4433 237.252 86.1243 234.062 86.1243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.939 83.9173C217.375 83.9173 219.706 79.8682 219.461 74.9602C219.461 74.5921 219.461 73.9786 219.461 73.6105L219.215 72.6289L208.295 72.997V73.9786C208.295 74.3467 208.295 74.9602 208.295 75.3283C208.172 80.1136 210.872 83.9173 213.939 83.9173Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 96L156.5 100L163.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 96L60.5 100L67.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 129,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 26.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 112.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 6.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188 5.5L195 15",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204 119.5L199 131.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 24L266 14.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(96 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(184 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceSteps);
export default __webpack_public_path__ + "static/media/persistence-steps.9497edbaf7d5597e9713c879f4f4f8fd.svg";
export { ForwardRef as ReactComponent };